import { useState } from "react";
import { Constants } from "constants/Constants";
import { storeData } from "common/utils/fnAsyncStorage";
// eslint-disable-next-line import/no-named-as-default
import useAuth from "./useAuth";

type OAuthProvider = "microsoft" | "google";

export function useOAuth(provider: OAuthProvider) {
  const [loading, setLoading] = useState(false);
  const { refreshUser } = useAuth();

  const signIn = async () => {
    try {
      setLoading(true);

      // Construire l'URL de redirection pour le callback
      const redirectUrl = `${window.location.origin}/callback`;
      const authUrl = `${
        Constants.ROOT_URL
      }/api/connect/${provider}?callback=${encodeURIComponent(redirectUrl)}`;

      // console.log("Redirect URL:", redirectUrl);
      // console.log("Auth URL:", authUrl);

      // Rediriger vers l'URL d'authentification OAuth
      window.location.href = authUrl;
    } catch (error) {
      console.error("Erreur auth:", error);
      setLoading(false);
    }
  };

  const handleAuthCallback = async (accessToken: string) => {
    try {
      setLoading(true);

      // Récupérer le JWT depuis Strapi
      const response = await fetch(
        `${Constants.API_URL}/auth/${provider}/callback?access_token=${accessToken}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Erreur lors de la récupération du token");
      }

      const data = await response.json();

      // console.log("data", data);

      if (data.jwt) {
        // Sauvegarder le JWT Strapi
        await storeData("token", data.jwt);
        if (data.user?.id) {
          await storeData("userId", data.user.id.toString());
        }

        // Rafraîchir l'utilisateur via le AuthProvider
        await refreshUser();
        return true;
      }
      throw new Error("JWT non reçu dans la réponse");
    } catch (error) {
      console.error("Erreur callback:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    signIn,
    handleAuthCallback,
  };
}

export default useOAuth;
